export default __webpack_public_path__ + "assets/icons/close-pic.da8c0c10.svg";